module.exports = __webpack_public_path__ + "static/media/screenshot(15).492b1de9.jpg";